import { ImageElementType } from 'polotno/model/image-model';
import { AvatarView } from '../ViewControl';

export const saveViewCache = (avatarElement: ImageElementType) => {
    const view = avatarElement.custom.view;

    avatarElement.set({
        custom: {
            ...(avatarElement.custom || {}),
            viewCache: {
                ...(avatarElement.custom.viewCache || {}),
                [view]: {
                    cropX: avatarElement.cropX,
                    cropY: avatarElement.cropY,
                    cropWidth: avatarElement.cropWidth,
                    cropHeight: avatarElement.cropHeight,
                    width: avatarElement.width,
                    height: avatarElement.height,
                    clipSrc: avatarElement.clipSrc,
                    shadowEnabled: avatarElement.shadowEnabled,
                    shadowBlur: avatarElement.shadowBlur,
                    shadowColor: avatarElement.shadowColor,
                    shadowOffsetX: avatarElement.shadowOffsetX,
                    shadowOffsetY: avatarElement.shadowOffsetY,
                    shadowOpacity: avatarElement.shadowOpacity,
                },
            },
        },
    });
};

export const getViewCache = (avatarElement: ImageElementType, view: AvatarView) => {
    return avatarElement?.custom?.viewCache?.[view];
};

const getCenteredCoordinates = (avatarElement: ImageElementType, width: number, height: number) => {
    const originalAvatarX = avatarElement.x + avatarElement.width / 2;
    const originalAvatarY = avatarElement.y + avatarElement.height / 2;

    return {
        x: originalAvatarX - width / 2,
        y: originalAvatarY - height / 2,
    };
};

export const setCachedView = (avatarElement: ImageElementType, view: AvatarView) => {
    const viewCache = getViewCache(avatarElement, view);
    if (viewCache) {
        return avatarElement.set({
            ...viewCache,
            ...getCenteredCoordinates(avatarElement, viewCache.width, viewCache.height),
            custom: {
                ...(avatarElement.custom || {}),
                view,
            },
        });
    }
};
